import { defineNuxtPlugin } from '#app/nuxt'
import { LazyComponentCTANeedHelp, LazyModalContactMe, LazyTravelCalculatorHeader, LazyTravelComparer, LazyTravelContractErrorPopup, LazyTravelDocuments, LazyTravelHigherPricePopup, LazyTravelInfoBanner, LazyTravelLoadingBox, LazyTravelProgressBar, LazyTravelQualityIndexModal, LazyTravelDetailAdditionalInsuranceItem, LazyTravelDetailIncludedInsuranceItem, LazyTravelDetailItem, LazyTravelOfferListItem, LazyTravelOfferUpsellItem, LazyTravelStepInsuredPersonsInfo, LazyTravelStepPolicyHolder, LazyTravelThankyouPaymentDetails, LazyComponentPopupBottomBar, LazyPageLoanBanner, LazyPageLoanCalculateModal, LazyPageLoanCalculator, LazyPageLoanCalculatorSimple, LazyPageLoanCompare, LazyPageLoanExpenseBar, LazyPageLoanHeader, LazyPageLoanInfoTile, LazyPageLoanListHeader, LazyPageLoanOffers, LazyPageLoanPaymentCalculator, LazyPageLoanProvider, LazyPageLoanQualityModal, LazyPageLoanRedirectModal, LazyPageLoanSelect, LazyPageLoanSeoText, LazyPageLoanSwiper, LazyPageLoanTrustCards, LazyPageMortgageHyponamiruWidgetWrapper, LazyStoryblokButton, LazyStoryblokImage, LazyHeaderFinal, LazyHorizontalChecklist, LazyInfoBanner, LazyLeadContactForm, LazyBlogArticleItem, LazyBlogHeader, LazyBlogImageTiles, LazyBlogRightPanelList, LazyBlogRightPanelWrapper, LazyBlogTagItems, LazyBlogVisible, LazyBlogWrapper, LazyComponentAccordion, LazyComponentActionTile, LazyComponentAdviserArticleItem, LazyComponentCTAText, LazyComponentContentCards, LazyComponentDiscountCards, LazyComponentDividedCards, LazyComponentFAQAccordion, LazyComponentFloatingBar, LazyComponentFormStepper, LazyComponentGallery, LazyComponentImageTile, LazyComponentInfoBox, LazyComponentInternalCTAButtons, LazyComponentInternalLinks, LazyComponentItemsList, LazyComponentItemsListImage, LazyComponentLifeInsuranceTypes, LazyComponentLinkList, LazyComponentListTiles, LazyComponentLoanCard, LazyComponentMapContact, LazyComponentMiniCalculatorSP, LazyComponentNotificationBox, LazyComponentPageBlock, LazyComponentPageBlockAlt, LazyComponentPartnerSlideshow, LazyComponentProductTiles, LazyComponentPromotionBar, LazyComponentPropertyCards, LazyComponentQuote, LazyComponentRecommendedCards, LazyComponentReference, LazyComponentResource, LazyComponentSPZCalculator, LazyComponentSPZCalculatorViewAB, LazyComponentSPZCalculatorViewDefault, LazyComponentSPZCalculatorViewExtended, LazyComponentSPZCalculatorViewIcons, LazyComponentSPZCalculatorViewTile, LazyComponentStepper, LazyComponentStepperCards, LazyComponentStoryblokBlogArticleItem, LazyComponentSwiperBlog, LazyComponentSwiperProduct, LazyComponentSwiperTestimonial, LazyComponentTable, LazyComponentTestimonial, LazyComponentTextBlock, LazyComponentTextTile, LazyComponentTile, LazyComponentTilesFinal, LazyComponentTilesFinalViewDefault, LazyComponentTilesFinalViewList, LazyComponentTrustCards, LazyComponentTypeform, LazyComponentVideo, LazyComponentWizardFrame, LazyComponentWizardNetFinance, LazyComponentRichtextCheckedList, LazyComponentRichtextTooltip, LazyModalLeadContact, LazyModalRedirect, LazyPageAboutUsAboutBlock, LazyPageAboutUsEmployees, LazyPageAboutUsEmployeesCard, LazyPageAboutUsQuote, LazyPageAboutUsSwiperTimeline, LazyPageAboutUsSwiperTimelinePagination, LazyPageAboutUsTiles, LazyPageAboutUsTimeline, LazyPageCombinedHeader, LazyPageContactHeader, LazyPageEnergoLoader, LazyPageEnergoTabs, LazyPageEstateChecklistBlock, LazyPageEstateHeader, LazyPageEstateInsurancesBlock, LazyPageEstatePropertyCards, LazyPageEstateStepper, LazyPageHavHeader, LazyPageHomeESHeader, LazyPageHomeHeader, LazyPageHouseholdHeader, LazyPageInsuranceHeader, LazyPagePovHeader, LazyPagePovStepper, LazyPagePovTextBlock, LazyPagePropertyHeader, LazyPagePropertyTextBlock, LazyPageResponsibilityButtons, LazyPageResponsibilityHeader, LazyPageResponsibilityInsurancesBlock, LazyPageResponsibilityPropertyCards, LazyPageResponsibilityStepper, LazyPageTravelHeader, LazyPageVideoHeader, LazyPressArticle, LazyPressContact, LazyStepCarInsuranceGeneratePdf, LazyStepCarInsuranceSendNotice, LazyStepCarInsuranceTerminationInput, LazyComponentCalculatorPackages, LazyComponentMiniCalculatorInternet, LazyComponentPopupSpeedTest, LazyComponentTariffOfferButton, LazyComponentTelcoSwiper, LazyComponentTelcoTariffSwiper, LazyModalSaveOffer, LazyPageTelcoHeader, LazySvgoCoreEuStars, LazySvgoCoreFacebookLogo, LazySvgoCoreSkFlag, LazySvgoCoreTwitterLogo, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["ComponentCTANeedHelp", LazyComponentCTANeedHelp],
["ModalContactMe", LazyModalContactMe],
["TravelCalculatorHeader", LazyTravelCalculatorHeader],
["TravelComparer", LazyTravelComparer],
["TravelContractErrorPopup", LazyTravelContractErrorPopup],
["TravelDocuments", LazyTravelDocuments],
["TravelHigherPricePopup", LazyTravelHigherPricePopup],
["TravelInfoBanner", LazyTravelInfoBanner],
["TravelLoadingBox", LazyTravelLoadingBox],
["TravelProgressBar", LazyTravelProgressBar],
["TravelQualityIndexModal", LazyTravelQualityIndexModal],
["TravelDetailAdditionalInsuranceItem", LazyTravelDetailAdditionalInsuranceItem],
["TravelDetailIncludedInsuranceItem", LazyTravelDetailIncludedInsuranceItem],
["TravelDetailItem", LazyTravelDetailItem],
["TravelOfferListItem", LazyTravelOfferListItem],
["TravelOfferUpsellItem", LazyTravelOfferUpsellItem],
["TravelStepInsuredPersonsInfo", LazyTravelStepInsuredPersonsInfo],
["TravelStepPolicyHolder", LazyTravelStepPolicyHolder],
["TravelThankyouPaymentDetails", LazyTravelThankyouPaymentDetails],
["ComponentPopupBottomBar", LazyComponentPopupBottomBar],
["PageLoanBanner", LazyPageLoanBanner],
["PageLoanCalculateModal", LazyPageLoanCalculateModal],
["PageLoanCalculator", LazyPageLoanCalculator],
["PageLoanCalculatorSimple", LazyPageLoanCalculatorSimple],
["PageLoanCompare", LazyPageLoanCompare],
["PageLoanExpenseBar", LazyPageLoanExpenseBar],
["PageLoanHeader", LazyPageLoanHeader],
["PageLoanInfoTile", LazyPageLoanInfoTile],
["PageLoanListHeader", LazyPageLoanListHeader],
["PageLoanOffers", LazyPageLoanOffers],
["PageLoanPaymentCalculator", LazyPageLoanPaymentCalculator],
["PageLoanProvider", LazyPageLoanProvider],
["PageLoanQualityModal", LazyPageLoanQualityModal],
["PageLoanRedirectModal", LazyPageLoanRedirectModal],
["PageLoanSelect", LazyPageLoanSelect],
["PageLoanSeoText", LazyPageLoanSeoText],
["PageLoanSwiper", LazyPageLoanSwiper],
["PageLoanTrustCards", LazyPageLoanTrustCards],
["PageMortgageHyponamiruWidgetWrapper", LazyPageMortgageHyponamiruWidgetWrapper],
["StoryblokButton", LazyStoryblokButton],
["StoryblokImage", LazyStoryblokImage],
["HeaderFinal", LazyHeaderFinal],
["HorizontalChecklist", LazyHorizontalChecklist],
["InfoBanner", LazyInfoBanner],
["LeadContactForm", LazyLeadContactForm],
["BlogArticleItem", LazyBlogArticleItem],
["BlogHeader", LazyBlogHeader],
["BlogImageTiles", LazyBlogImageTiles],
["BlogRightPanelList", LazyBlogRightPanelList],
["BlogRightPanelWrapper", LazyBlogRightPanelWrapper],
["BlogTagItems", LazyBlogTagItems],
["BlogVisible", LazyBlogVisible],
["BlogWrapper", LazyBlogWrapper],
["ComponentAccordion", LazyComponentAccordion],
["ComponentActionTile", LazyComponentActionTile],
["ComponentAdviserArticleItem", LazyComponentAdviserArticleItem],
["ComponentCTAText", LazyComponentCTAText],
["ComponentContentCards", LazyComponentContentCards],
["ComponentDiscountCards", LazyComponentDiscountCards],
["ComponentDividedCards", LazyComponentDividedCards],
["ComponentFAQAccordion", LazyComponentFAQAccordion],
["ComponentFloatingBar", LazyComponentFloatingBar],
["ComponentFormStepper", LazyComponentFormStepper],
["ComponentGallery", LazyComponentGallery],
["ComponentImageTile", LazyComponentImageTile],
["ComponentInfoBox", LazyComponentInfoBox],
["ComponentInternalCTAButtons", LazyComponentInternalCTAButtons],
["ComponentInternalLinks", LazyComponentInternalLinks],
["ComponentItemsList", LazyComponentItemsList],
["ComponentItemsListImage", LazyComponentItemsListImage],
["ComponentLifeInsuranceTypes", LazyComponentLifeInsuranceTypes],
["ComponentLinkList", LazyComponentLinkList],
["ComponentListTiles", LazyComponentListTiles],
["ComponentLoanCard", LazyComponentLoanCard],
["ComponentMapContact", LazyComponentMapContact],
["ComponentMiniCalculatorSP", LazyComponentMiniCalculatorSP],
["ComponentNotificationBox", LazyComponentNotificationBox],
["ComponentPageBlock", LazyComponentPageBlock],
["ComponentPageBlockAlt", LazyComponentPageBlockAlt],
["ComponentPartnerSlideshow", LazyComponentPartnerSlideshow],
["ComponentProductTiles", LazyComponentProductTiles],
["ComponentPromotionBar", LazyComponentPromotionBar],
["ComponentPropertyCards", LazyComponentPropertyCards],
["ComponentQuote", LazyComponentQuote],
["ComponentRecommendedCards", LazyComponentRecommendedCards],
["ComponentReference", LazyComponentReference],
["ComponentResource", LazyComponentResource],
["ComponentSPZCalculator", LazyComponentSPZCalculator],
["ComponentSPZCalculatorViewAB", LazyComponentSPZCalculatorViewAB],
["ComponentSPZCalculatorViewDefault", LazyComponentSPZCalculatorViewDefault],
["ComponentSPZCalculatorViewExtended", LazyComponentSPZCalculatorViewExtended],
["ComponentSPZCalculatorViewIcons", LazyComponentSPZCalculatorViewIcons],
["ComponentSPZCalculatorViewTile", LazyComponentSPZCalculatorViewTile],
["ComponentStepper", LazyComponentStepper],
["ComponentStepperCards", LazyComponentStepperCards],
["ComponentStoryblokBlogArticleItem", LazyComponentStoryblokBlogArticleItem],
["ComponentSwiperBlog", LazyComponentSwiperBlog],
["ComponentSwiperProduct", LazyComponentSwiperProduct],
["ComponentSwiperTestimonial", LazyComponentSwiperTestimonial],
["ComponentTable", LazyComponentTable],
["ComponentTestimonial", LazyComponentTestimonial],
["ComponentTextBlock", LazyComponentTextBlock],
["ComponentTextTile", LazyComponentTextTile],
["ComponentTile", LazyComponentTile],
["ComponentTilesFinal", LazyComponentTilesFinal],
["ComponentTilesFinalViewDefault", LazyComponentTilesFinalViewDefault],
["ComponentTilesFinalViewList", LazyComponentTilesFinalViewList],
["ComponentTrustCards", LazyComponentTrustCards],
["ComponentTypeform", LazyComponentTypeform],
["ComponentVideo", LazyComponentVideo],
["ComponentWizardFrame", LazyComponentWizardFrame],
["ComponentWizardNetFinance", LazyComponentWizardNetFinance],
["ComponentRichtextCheckedList", LazyComponentRichtextCheckedList],
["ComponentRichtextTooltip", LazyComponentRichtextTooltip],
["ModalLeadContact", LazyModalLeadContact],
["ModalRedirect", LazyModalRedirect],
["PageAboutUsAboutBlock", LazyPageAboutUsAboutBlock],
["PageAboutUsEmployees", LazyPageAboutUsEmployees],
["PageAboutUsEmployeesCard", LazyPageAboutUsEmployeesCard],
["PageAboutUsQuote", LazyPageAboutUsQuote],
["PageAboutUsSwiperTimeline", LazyPageAboutUsSwiperTimeline],
["PageAboutUsSwiperTimelinePagination", LazyPageAboutUsSwiperTimelinePagination],
["PageAboutUsTiles", LazyPageAboutUsTiles],
["PageAboutUsTimeline", LazyPageAboutUsTimeline],
["PageCombinedHeader", LazyPageCombinedHeader],
["PageContactHeader", LazyPageContactHeader],
["PageEnergoLoader", LazyPageEnergoLoader],
["PageEnergoTabs", LazyPageEnergoTabs],
["PageEstateChecklistBlock", LazyPageEstateChecklistBlock],
["PageEstateHeader", LazyPageEstateHeader],
["PageEstateInsurancesBlock", LazyPageEstateInsurancesBlock],
["PageEstatePropertyCards", LazyPageEstatePropertyCards],
["PageEstateStepper", LazyPageEstateStepper],
["PageHavHeader", LazyPageHavHeader],
["PageHomeESHeader", LazyPageHomeESHeader],
["PageHomeHeader", LazyPageHomeHeader],
["PageHouseholdHeader", LazyPageHouseholdHeader],
["PageInsuranceHeader", LazyPageInsuranceHeader],
["PagePovHeader", LazyPagePovHeader],
["PagePovStepper", LazyPagePovStepper],
["PagePovTextBlock", LazyPagePovTextBlock],
["PagePropertyHeader", LazyPagePropertyHeader],
["PagePropertyTextBlock", LazyPagePropertyTextBlock],
["PageResponsibilityButtons", LazyPageResponsibilityButtons],
["PageResponsibilityHeader", LazyPageResponsibilityHeader],
["PageResponsibilityInsurancesBlock", LazyPageResponsibilityInsurancesBlock],
["PageResponsibilityPropertyCards", LazyPageResponsibilityPropertyCards],
["PageResponsibilityStepper", LazyPageResponsibilityStepper],
["PageTravelHeader", LazyPageTravelHeader],
["PageVideoHeader", LazyPageVideoHeader],
["PressArticle", LazyPressArticle],
["PressContact", LazyPressContact],
["StepCarInsuranceGeneratePdf", LazyStepCarInsuranceGeneratePdf],
["StepCarInsuranceSendNotice", LazyStepCarInsuranceSendNotice],
["StepCarInsuranceTerminationInput", LazyStepCarInsuranceTerminationInput],
["ComponentCalculatorPackages", LazyComponentCalculatorPackages],
["ComponentMiniCalculatorInternet", LazyComponentMiniCalculatorInternet],
["ComponentPopupSpeedTest", LazyComponentPopupSpeedTest],
["ComponentTariffOfferButton", LazyComponentTariffOfferButton],
["ComponentTelcoSwiper", LazyComponentTelcoSwiper],
["ComponentTelcoTariffSwiper", LazyComponentTelcoTariffSwiper],
["ModalSaveOffer", LazyModalSaveOffer],
["PageTelcoHeader", LazyPageTelcoHeader],
["SvgoCoreEuStars", LazySvgoCoreEuStars],
["SvgoCoreFacebookLogo", LazySvgoCoreFacebookLogo],
["SvgoCoreSkFlag", LazySvgoCoreSkFlag],
["SvgoCoreTwitterLogo", LazySvgoCoreTwitterLogo],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
